import { render, staticRenderFns } from "./InsightsDashboard.vue?vue&type=template&id=2c0b6c91&"
import script from "./InsightsDashboard.vue?vue&type=script&lang=js&"
export * from "./InsightsDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports